'use client';
import { Button } from '@/components/ui/buttons';
import { useTranslations } from 'next-intl';
import React, { useState } from 'react';
import ReturnModal from './modals/return-product';
import RateModal from './modals/rate-product';
import { toast } from '@/utils/toast';
import { returnProducts, reviewProduct } from '@/services/user/orders';

const currentUser = {
  firstname: 'Abdo',
  lastname: 'Elmorsi',
};

const defaultState = {
  isOpenRate: false,
  isLoadingRate: false,
  isOpenReturn: false,
  isLoadingReturn: false,
};
function CardActions({ product, mage }) {
  const t = useTranslations('');

  // Combined modal states for better management
  const [modalState, setModalState] = useState(defaultState);

  const toggleModal = (type, state) => {
    setModalState((prev) => ({ ...prev, [type]: state }));
  };

  const onRate = async (desc) => {
    toggleModal('isLoadingRate', true);
    try {
      const res = await reviewProduct({
        mage,
        user: currentUser,
        rate: 5,
        desc,
        product_id: product?.item_id,
      });
      if (res.status == 200) {
        toast.success(t(res?.data?.message));
      }
    } catch (err) {
      toast.error(err?.message || t('common.unknwen_error_key'));
    } finally {
      setModalState(defaultState);
    }
  };

  const onReturn = async () => {
    toggleModal('isLoadingReturn', true);
    try {
      const res = await returnProducts({
        mage,
        orderId: product?.order_id,
        items: [product?.item_id],
      });
      if (res.status == 200) {
        toast.success(t('user.' + res?.data?.data?.message?.replace('.', '')));
      } else {
        toast.error(t('user.' + res?.error?.error?.message?.replace('.', '')));
      }
    } catch (err) {
      toast.error(err?.message || "Can't return product");
    } finally {
      setModalState(defaultState);
    }
  };

  return (
    <>
      <div className='flex items-center gap-2'>
        <Button
          onClick={() => toggleModal('isOpenReturn', true)}
          className='!text-primary border-border w-26 border-2 bg-transparent !p-1 text-sm md:w-38 md:text-base'
        >
          {t('user.return_key')}
        </Button>

        <Button
          onClick={() => toggleModal('isOpenRate', true)}
          className='w-26 !p-1 text-sm md:w-38 md:text-base'
        >
          {t('user.rate_product_key')}
        </Button>
      </div>

      {modalState.isOpenRate && (
        <RateModal
          product={product}
          isOpen={modalState.isOpenRate}
          onClose={() => toggleModal('isOpenRate', false)}
          isLoading={modalState.isLoadingRate}
          onRate={onRate}
        />
      )}

      {modalState.isOpenReturn && (
        <ReturnModal
          product={product}
          isOpen={modalState.isOpenReturn}
          onClose={() => toggleModal('isOpenReturn', false)}
          isLoading={modalState.isLoadingReturn}
          onReturn={onReturn}
          mage={mage}
        />
      )}
    </>
  );
}

export default CardActions;
